import { IsNotEmpty, IsOptional, IsNumber } from "class-validator";

export class EventDocumentDto {
  @IsNotEmpty()
  name: string;

  @IsOptional()
  description?: string;

  @IsNotEmpty()
  file_url: string;

  @IsNotEmpty()
  file_name: string;

  @IsNumber()
  file_size: number;

  @IsNotEmpty()
  mime_type: string;
}

export class UpdateEventDocumentDto {
  @IsOptional()
  name?: string;

  @IsOptional()
  description?: string;
}
